import Typography from '~/shared/components/Typography';

import { formatBytesWithValueAndUnit } from '../utils/formatNumber';

export default function SizeCell({
  size,
  dataTooltipId,
  sizeInGiB,
}: {
  size: number;
  dataTooltipId?: string;
  sizeInGiB?: boolean;
}) {
  const formatted = sizeInGiB ? { value: size, unit: 'GiB' } : formatBytesWithValueAndUnit(size, 1);
  const { value, unit } = formatted;

  return (
    <div data-tooltip-id={dataTooltipId} className="flex items-center gap-[6px] font-family-inter">
      <Typography fontWeight={500} variant="p3" color="text-primary-900">
        {value}
      </Typography>
      {unit && (
        <Typography fontWeight={500} variant="p3" color="text-gray">
          {unit}
        </Typography>
      )}
    </div>
  );
}
